/* tslint:disable */
import {
  PropertyUnits,
  CompanyAccount,
  FileManager,
  IncomeInvoice,
  TenantDeposit,
  TenantLease,
  TenantFee,
  RecurringCharge,
  TempLeaseRenewal,
  CreditNote,
  LeaseTermination,
  LeaseRenewTemp
} from '../index';

declare var Object: any;
export interface LeaseInterface {
  "name": string;
  "start_date"?: Date;
  "end_date"?: Date;
  "billing_start_date"?: Date;
  "lease_review_date"?: Date;
  "status": string;
  "rent_amount"?: number;
  "frequency"?: string;
  "automatically_end"?: boolean;
  "property_id": number;
  "property_unit_id": number;
  "chart_of_account_id"?: number;
  "tax_percentage"?: number;
  "billing_end_date"?: Date;
  "tenant_lease_id"?: number;
  "lease_type"?: string;
  "original_lease_id"?: number;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  propertyUnits?: PropertyUnits;
  property?: CompanyAccount;
  files?: FileManager[];
  incomeInvoice?: IncomeInvoice[];
  tenantDeposits?: TenantDeposit[];
  tenantsLease?: TenantLease;
  tenantLease?: TenantLease;
  tenantFees?: TenantFee[];
  recurrentCharges?: RecurringCharge[];
  proposedLease?: TempLeaseRenewal;
  creditNote?: CreditNote;
  leaseTermination?: LeaseTermination;
  leaseRenewTemps?: LeaseRenewTemp;
}

export class Lease implements LeaseInterface {
  "name": string;
  "start_date": Date;
  "end_date": Date;
  "billing_start_date": Date;
  "lease_review_date": Date;
  "status": string;
  "rent_amount": number;
  "frequency": string;
  "automatically_end": boolean;
  "property_id": number;
  "property_unit_id": number;
  "chart_of_account_id": number;
  "tax_percentage": number;
  "billing_end_date": Date;
  "tenant_lease_id": number;
  "lease_type": string;
  "original_lease_id": number;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  propertyUnits: PropertyUnits;
  property: CompanyAccount;
  files: FileManager[];
  incomeInvoice: IncomeInvoice[];
  tenantDeposits: TenantDeposit[];
  tenantsLease: TenantLease;
  tenantLease: TenantLease;
  tenantFees: TenantFee[];
  recurrentCharges: RecurringCharge[];
  proposedLease: TempLeaseRenewal;
  creditNote: CreditNote;
  leaseTermination: LeaseTermination;
  leaseRenewTemps: LeaseRenewTemp;
  constructor(data?: LeaseInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Lease`.
   */
  public static getModelName() {
    return "Lease";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Lease for dynamic purposes.
  **/
  public static factory(data: LeaseInterface): Lease{
    return new Lease(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Lease',
      plural: 'Leases',
      path: 'Leases',
      idName: 'id',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "start_date": {
          name: 'start_date',
          type: 'Date'
        },
        "end_date": {
          name: 'end_date',
          type: 'Date'
        },
        "billing_start_date": {
          name: 'billing_start_date',
          type: 'Date'
        },
        "lease_review_date": {
          name: 'lease_review_date',
          type: 'Date'
        },
        "status": {
          name: 'status',
          type: 'string',
          default: 'TEMPORARY'
        },
        "rent_amount": {
          name: 'rent_amount',
          type: 'number'
        },
        "frequency": {
          name: 'frequency',
          type: 'string'
        },
        "automatically_end": {
          name: 'automatically_end',
          type: 'boolean'
        },
        "property_id": {
          name: 'property_id',
          type: 'number'
        },
        "property_unit_id": {
          name: 'property_unit_id',
          type: 'number'
        },
        "chart_of_account_id": {
          name: 'chart_of_account_id',
          type: 'number'
        },
        "tax_percentage": {
          name: 'tax_percentage',
          type: 'number',
          default: 0
        },
        "billing_end_date": {
          name: 'billing_end_date',
          type: 'Date'
        },
        "tenant_lease_id": {
          name: 'tenant_lease_id',
          type: 'number'
        },
        "lease_type": {
          name: 'lease_type',
          type: 'string',
          default: 'NORMAL'
        },
        "original_lease_id": {
          name: 'original_lease_id',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        propertyUnits: {
          name: 'propertyUnits',
          type: 'PropertyUnits',
          model: 'PropertyUnits',
          relationType: 'belongsTo',
                  keyFrom: 'property_unit_id',
          keyTo: 'id'
        },
        property: {
          name: 'property',
          type: 'CompanyAccount',
          model: 'CompanyAccount',
          relationType: 'belongsTo',
                  keyFrom: 'property_id',
          keyTo: 'id'
        },
        files: {
          name: 'files',
          type: 'FileManager[]',
          model: 'FileManager',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'model_item_id'
        },
        incomeInvoice: {
          name: 'incomeInvoice',
          type: 'IncomeInvoice[]',
          model: 'IncomeInvoice',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'lease_id'
        },
        tenantDeposits: {
          name: 'tenantDeposits',
          type: 'TenantDeposit[]',
          model: 'TenantDeposit',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'lease_id'
        },
        tenantsLease: {
          name: 'tenantsLease',
          type: 'TenantLease',
          model: 'TenantLease',
          relationType: 'hasOne',
                  keyFrom: 'id',
          keyTo: 'lease_id'
        },
        tenantLease: {
          name: 'tenantLease',
          type: 'TenantLease',
          model: 'TenantLease',
          relationType: 'hasOne',
                  keyFrom: 'id',
          keyTo: 'lease_id'
        },
        tenantFees: {
          name: 'tenantFees',
          type: 'TenantFee[]',
          model: 'TenantFee',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'lease_id'
        },
        recurrentCharges: {
          name: 'recurrentCharges',
          type: 'RecurringCharge[]',
          model: 'RecurringCharge',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'lease_id'
        },
        proposedLease: {
          name: 'proposedLease',
          type: 'TempLeaseRenewal',
          model: 'TempLeaseRenewal',
          relationType: 'hasOne',
                  keyFrom: 'id',
          keyTo: 'lease_id'
        },
        creditNote: {
          name: 'creditNote',
          type: 'CreditNote',
          model: 'CreditNote',
          relationType: 'hasOne',
                  keyFrom: 'id',
          keyTo: 'lease_id'
        },
        leaseTermination: {
          name: 'leaseTermination',
          type: 'LeaseTermination',
          model: 'LeaseTermination',
          relationType: 'hasOne',
                  keyFrom: 'id',
          keyTo: 'lease_id'
        },
        leaseRenewTemps: {
          name: 'leaseRenewTemps',
          type: 'LeaseRenewTemp',
          model: 'LeaseRenewTemp',
          relationType: 'hasOne',
                  keyFrom: 'id',
          keyTo: 'lease_id'
        },
      }
    }
  }
}
